export default "__VITE_ASSET__54123b4b__"